import axios from 'axios';
import {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import config from '../../config/config';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './ServicesPage.module.scss';

function ServicesPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [isPreload, setPreload] = useState<boolean | null>(true);
    const [allServices, setAllServices] = useState<any[]>([]);

    useEffect(() => {
        if (location.hash) {
            const hash = decodeURIComponent(location.hash.substring(1));
            const [category, subcategory] = hash.split('-');
            navigate(`/subservices/${encodeURIComponent(category)}/${encodeURIComponent(subcategory)}`);
        }
    }, [location.hash, navigate]);

    useEffect(() => {
        if (config.url_provet_api) {
            setPreload(true);
            axios
                .get(`${config.url_provet_api}mysklad/services`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    setAllServices(response.data.response);
                    setPreload(false);
                })
                .catch(() => {
                    setPreload(null);
                });
        }
    }, []);

    const handleCardClick = (group: string) => {
        navigate(`/services/${encodeURIComponent(group)}`);
    };

    if (isPreload) {
        return (
            <div className={styles.section}>
                <div className={styles.inSection}>
                    <div className={styles.loadingContainer}>
                        <div className={styles.spinner}></div>
                        <p className={styles.loadingText}>Загружаем список услуг...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (isPreload === null) {
        return (
            <div className={styles.section}>
                <div className={styles.inSection}>
                    <div className={styles.errorContainer}>
                        <h2 className={styles.errorTitle}>Ошибка загрузки</h2>
                        <p className={styles.errorText}>
                            Не удалось загрузить данные о услугах. Пожалуйста, попробуйте позже.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <section className={styles.section}>
            <div className={styles.inSection}>
                <h1 className={styles.title}>
                    Наши услуги
                </h1>
                <p className={styles.subtitle}>
                    Выберите категорию для просмотра подробной информации
                </p>

                <Row className={`${styles.servicesRow} d-flex align-items-center justify-content-center m-0`}>
                    {allServices.map((group, groupIndex) => (
                        <Col key={groupIndex} xs={12} md={4} className={styles.serviceCol}>
                            <div
                                className={styles.serviceCard}
                                onClick={() => handleCardClick(group.name)}
                                role="button"
                                tabIndex={0}
                                onKeyPress={(e) => e.key === 'Enter' && handleCardClick(group.name)}
                            >
                                <div className={styles.cardHeader}>
                                    <div className={styles.categoryIcon}>
                                        {group.name.charAt(0).toUpperCase()}
                                    </div>
                                    <h3 className={styles.categoryName}>
                                        {group.name}
                                    </h3>
                                </div>

                                <div className={styles.servicesList}>
                                    {group.services.slice(0, 4).map((service: any, serviceIndex: number) => (
                                        <div key={serviceIndex} className={styles.serviceItem}>
                                            <span className={styles.serviceName}>{service.name}</span>
                                            <span className={styles.servicePrice}>{service.price} ₽</span>
                                        </div>
                                    ))}
                                    {group.services.length > 4 && (
                                        <div className={styles.moreServices}>
                                            + Показать все ({group.services.length - 4} еще)
                                        </div>
                                    )}
                                </div>

                                <div className={styles.cardFooter}>
                                    <span className={styles.totalCount}>{group.services.length} услуг</span>
                                    <div className={styles.viewMore}>
                                        Подробнее
                                        <span className={styles.arrow}>→</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </section>
    );
}

export default ServicesPage;